import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { FaSearch, FaUser } from "react-icons/fa";
import logoWhite from "../../images/microlifebgremove.png";
import {
  FiHeart,
  FiLogOut,
  FiPackage,
  FiShoppingCart,
  FiUser,
} from "react-icons/fi";
import { IoCartSharp, IoWallet } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { FaShop } from "react-icons/fa6";
import { GiTwoCoins } from "react-icons/gi";
import { IoIosAppstore, IoLogoAndroid, IoMdWallet } from "react-icons/io";
import { MdInstallMobile } from "react-icons/md";
import { useSelector } from "react-redux";
import { MyContext } from "../../context/MyContext";

const Navbar = () => {
  const {
    search,
    setSearch,
    exitUserId,
    getSearchItem,
    serchItem,
    setSearchItem,
    MLMStatus,
    cartItems,
    verifyMlmUser,
    checkMLMUser,
    fetchCartItems,
  } = useContext(MyContext);
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);

  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  checkMLMUser();

  useEffect(() => {
    getSearchItem(serchItem);
  }, [serchItem]);

  useEffect(() => {
    if (serchItem) {
      navigate("/product-search");
    } else {
      navigate("/");
    }
  }, [serchItem]);

  const handleSearch = () => {
    if (serchItem) {
      navigate("/product-search");
    }
  };

  return (
    <nav className="navbar top-0 z-50 bg-white pt-1 pb-1 shadow-md">
      <div className="navbar-container flex justify-between items-center m-1 md:m-3 max-sm:h-[40px]">
        {/* Logo */}
        <div className="flex-shrink-0 sm:text-[20px]">
          <Link to="/">
            <img src={logoWhite} alt="logo" className="w-24 h-16" />
          </Link>
        </div>
        <p className="text-black font-bold text-[20px] ml-5 hidden sm:inline mr-5">
          <Link to="/">Our MicroLife</Link>
        </p>
        {/* Become Seller */}
        <div className="card flex justify-start items-center text-black font-bold text-2xl ml-5 cursor-pointer relative">
          <a
            href="https://vendor.ourmicrolife.com/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center"
          >
            <FaShop size={26} className="font-bold" />
            <button className="text-black font-semibold text-[18px] hidden lg:block ml-2 bg-white border-2 border-purple-700 rounded-lg px-4 py-1 hover:bg-purple-700 hover:text-white transition duration-300 ease-in-out">
              Become Seller
            </button>
          </a>
        </div>

        {/* Search Bar */}
        <div className="flex-grow flex justify-center items-center hidden lg:block lg:ml-10">
          <div className="bg-white sm:flex items-center border-2 border-gray-300 rounded-2xl p-1 w-full max-w-[30px] md:max-w-xl lg:max-w-[30px] xl:max-w-3xl">
            <input
              type="text"
              value={serchItem}
              onChange={(e) => setSearchItem(e.target.value)}
              placeholder="Searching Products..."
              className="search-input text-black p-2 ml-5 border-none w-full outline-none text-sm sm:text-base"
            />
            <FaSearch className="mr-5 text-black" onClick={handleSearch} />
          </div>
        </div>

        <div className="returnCard flex flex-col mr-18 ml-8 cursor-pointer hidden sm:inline relative">
          <Link to="/account/myorders">
            <p className="text-black cursor-pointer">Returns</p>
            <p className="text-black font-semibold cursor-pointer">& Orders </p>
          </Link>
        </div>

        {/* Icons */}
        <div className="flex-shrink-0 flex items-center space-x-3 lg:pr-5 sm:ml-5 max-sm:space-x-0">
          <div className="relative group">
            <div className="flex items-center space-x-2 text-black rounded-lg p-2 hover:bg-white hover:white-purple-700 text-sm sm:text-base">
              <MdInstallMobile size={24} className="cursor-pointer" />
            </div>
            <div className="absolute top-9 z-50 left-0 mt-1 lg:w-55 bg-white shadow-lg rounded-lg py-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 invisible group-hover:visible">
              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noreferrer"
                className="flex items-center px-4 py-2 hover:bg-purple-50 text-gray-800"
              >
                <IoLogoAndroid className="mr-2 text-green-500" size={20} />
                <p className="hidden sm:inline">Android</p>
              </a>
              <a
                href="https://www.apple.com/app-store/"
                target="_blank"
                rel="noreferrer"
                className="flex items-center px-4 py-2 hover:bg-purple-50 text-gray-800"
              >
                <IoIosAppstore className="mr-2 text-blue-500" size={20} />
                <p className="hidden sm:inline">iOS</p>
              </a>
            </div>
          </div>

          <div className="relative group">
            <Link
              to={exitUserId ? "/account/account_details" : "/login-user"}
              className="flex items-center space-x-2 text-black p-2 rounded-lg hover:bg-white hover:text-purple-700 text-sm sm:text-base"
            >
              <FaUser size={20} />
              <span className="hidden md:inline">
                {exitUserId ? "" : "Login"}
              </span>
            </Link>

            {/* Dropdown */}
            {exitUserId && (
              <div className="absolute top-full right-0 mt-0 w-40 bg-white shadow-lg rounded-lg py-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 invisible group-hover:visible">
                <Link
                  to="/account/account_details"
                  className="block px-4 py-2 hover:bg-purple-100 text-gray-800 flex items-center space-x-2"
                >
                  <FiUser className="text-blue-500 text-xl" />
                  <span>Profile</span>
                </Link>
                <Link
                  to="/cart"
                  className="block px-4 py-2 hover:bg-purple-100 text-gray-800 flex items-center space-x-2"
                >
                  <FiShoppingCart className="text-green-500 text-xl" />
                  <span>Cart</span>
                </Link>
                <Link
                  to="/account/myorders"
                  className="block px-4 py-2 hover:bg-purple-100 text-gray-800 flex items-center space-x-2"
                >
                  <FiPackage className="text-yellow-500 text-xl" />
                  <span>Orders</span>
                </Link>
                <Link
                  to="/account/wishlist-products"
                  className="block px-4 py-2 hover:bg-purple-100 text-gray-800 flex items-center space-x-2"
                >
                  <FiHeart className="text-red-500 text-xl" />
                  <span>Wishlist</span>
                </Link>
                <button
                  onClick={() => {
                    localStorage.removeItem("token");
                    localStorage.clear();
                    checkMLMUser();
                    navigate("/");
                  }}
                  className="block w-full text-left px-4 py-2 hover:bg-purple-100 text-gray-800 flex items-center space-x-2"
                >
                  <FiLogOut className="text-gray-500 text-xl" />
                  <span>Sign Out</span>
                </button>
              </div>
            )}
          </div>

          {/* Add to Cart Icon */}
          <Link
            to="/cart"
            className="flex items-center space-x-2 p-2 text-black rounded-lg hover:bg-white hover:text-purple-700 relative block group"
          >
            <IoCartSharp size={24} />
            {cartItems.length > 0 && (
              <span className="absolute top-0 right-0 inline-block h-5 w-5 rounded-full bg-red-600 text-white text-xs font-bold flex items-center justify-center">
                {cartItems.length}
              </span>
            )}
          </Link>

          {/* Wallet Icon */}
        {verifyMlmUser?<Link
            to="/account/your-wallet"
            className="flex items-center space-x-2 p-2 text-black rounded-lg hover:bg-purple-100 hover:text-purple-700 hidden md:block"
          >
            <IoMdWallet className="text-xl text-black" />
          </Link>:""}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;


